import { CustomNextPage } from '../lib/types';
import { PROFILE_PAGE_QUERY } from '../modules/Profile/graphql';
import { profilePageQuery } from '../core-types';
import { bootstrap } from '../lib/bootstrap';
import { Wallet } from '../modules/Profile/Wallet/Wallet';
import { useCurrentUser } from '../lib/core/useCurrentUser';

const WalletPage: CustomNextPage<{}> = () => {
  const { currentUser } = useCurrentUser();
  if (!currentUser) {
    return null;
  }
  return <Wallet currentUser={currentUser} />;
};

WalletPage.getInitialProps = async ctx => {
  const profilePageQueryResult = await ctx.apolloClient.query<profilePageQuery>(
    {
      query: PROFILE_PAGE_QUERY
    }
  );
  let statusCode;
  if (!profilePageQueryResult.data?.profilePage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    statusCode
  };
};

export default bootstrap(WalletPage);
